import React from 'react'
import { Stack } from "@mui/material";
import { Link } from "react-router-dom";

const ShowRouting = ({ route }) => {
    return (
        <div
            style={{ width: "100%", backgroundColor: "white" }}
            className="pt-6 pb-6"
        >
            <Stack
                direction="row"
            >
                <div>
                    <Link to='/create-request'>
                        {route}
                    </Link>
                </div>


            </Stack>
        </div>

    )
}

export default ShowRouting